"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hitagi_plugin_im_1 = __importDefault(require("./hitagi_plugin_im"));
const hitagi_plugin_chat_1 = __importDefault(require("./hitagi_plugin_chat"));
const hitagi_plugin_capabilities_1 = __importDefault(require("./hitagi_plugin_capabilities"));
const hitagi_plugin_media_1 = __importDefault(require("./hitagi_plugin_media"));
const hitagi_plugin_status_1 = __importDefault(require("./hitagi_plugin_status"));
const hitagi_plugin_room_1 = __importDefault(require("./hitagi_plugin_room"));
const hitagi_plugin_stream_1 = __importDefault(require("./hitagi_plugin_stream"));
const hitagi_plugin_utils_1 = __importDefault(require("./hitagi_plugin_utils"));
class hitagi {
    constructor(Config) {
        this.config = {
            "Name": "Hitagi",
            "SnapshotIntervalSec": 60,
            "SnapshotWidth": 256,
            "SnapshotHeight": 192
        };
        this.logged = false;
        this.connection_status = "disconnected";
        this.message_counter = 0;
        this.message_queue = {};
        this.ping_interval = 0;
        this.events = {};
        this.callback_queue = [];
        this.capabilities = new hitagi_plugin_capabilities_1.default();
        this.media = new hitagi_plugin_media_1.default(this);
        this.utils = new hitagi_plugin_utils_1.default();
        this.stream = new hitagi_plugin_stream_1.default(this);
        this.status = new hitagi_plugin_status_1.default(this);
        this.room = new hitagi_plugin_room_1.default(this);
        this.im = new hitagi_plugin_im_1.default(this);
        this.chat = new hitagi_plugin_chat_1.default(this);
        this.logged = false;
        this.connection_status = "disconnected";
        this.message_counter = 0;
        this.message_queue = [];
        this.ping_interval = 0;
        this.events = {};
        this.callback_queue = [];
        if (Config) {
            this.set_config(Config);
        }
        return this;
    }
    error(Code, Message) {
        this.log("Error #" + Code + ": " + Message);
        this.fire_event("error", { "result": "error", "code": Code, "message": Message });
        return { "result": "error", "code": Code, "message": Message };
    }
    error_not_connected() {
        return this.error(1, "Not connected");
    }
    error_socket_error() {
        return this.error(2, "Socket error");
    }
    error_config_error() {
        return this.error(3, "Configuration error");
    }
    error_message_timeout(Message) {
        return this.error(4, "Message #" + Message.args.messageid + " timeout");
    }
    error_unrecognized_response(Message) {
        return this.error(5, "Unrecognized|malformed response from server: " + Message);
    }
    error_wrong_messageid(Data) {
        return this.error(6, "Wrong messageid from server: " + Data);
    }
    error_server_error(Data) {
        return this.error(7, "Server error occurred. " + Data);
    }
    set_config(Config) {
        if (Config.Uid) {
            this.config.Uid = Config.Uid;
        }
        if (Config.Token) {
            this.config.Token = Config.Token;
        }
        if (Config.RoomId) {
            this.config.RoomId = Config.RoomId;
        }
        if (Config.ChatroomName) {
            this.config.ChatroomName = Config.ChatroomName;
        }
        if (Config.PaymentAllowed) {
            this.config.PaymentAllowed = Config.PaymentAllowed;
        }
        if (Config.RoomPassword) {
            this.config.RoomPassword = Config.RoomPassword;
        }
        else {
            delete this.config.RoomPassword;
        }
        if (Config.ServerUri) {
            this.config.ServerUri = Config.ServerUri;
        }
        if (Config.Name) {
            this.config.Name = Config.Name;
        }
        if (Config.Nick) {
            this.config.Nick = Config.Nick;
        }
        if (Config.DeviceToken) {
            this.config.DeviceToken = Config.DeviceToken;
        }
        if (Config.AdditionalInfo) {
            this.config.AdditionalInfo = Config.AdditionalInfo;
        }
        if (Config.SnapshotIntervalSec) {
            this.config.SnapshotIntervalSec = Config.SnapshotIntervalSec;
        }
        else {
            this.config.SnapshotIntervalSec = 60;
        }
        if (Config.SnapshotWidth) {
            this.media.snapshotWidth = Config.SnapshotWidth;
        }
        if (Config.SnapshotHeight) {
            this.media.snapshotHeight = Config.SnapshotHeight;
        }
        if (Config.__debug__) {
            this.config.__debug__ = Config.__debug__;
        }
        this.config.Timeout = Config.Timeout ? Config.Timeout : 15000;
    }
    result_is_failed(ResultCode) {
        return Math.floor(ResultCode / 100) != 2;
    }
    parse_response_result(Response) {
        const MessageId = Response.messageid;
        const Result = Response.result;
        if (MessageId == "0" && this.result_is_failed(Result)) {
            return this.error_server_error(Response.result + " " + Response.comment);
        }
        if (!MessageId || !Result) {
            return this.error_unrecognized_response(Response);
        }
        if (!this.message_queue[MessageId]) {
            return this.error_wrong_messageid(Response);
        }
        const Message = this.message_queue[MessageId];
        if (!this.result_is_failed(Result)) {
            this.message_queue[MessageId].status = "success";
            if (Message.on_success) {
                Message.on_success(Response.data);
            }
        }
        else {
            this.message_queue[MessageId].status = "failed";
            this.error_server_error(Response.result + " " + Response.comment);
            if (Message.on_error) {
                Message.on_error(Result, Response.comment, Response.data);
            }
        }
        delete this.message_queue[MessageId];
    }
    on_socket_message(Data) {
        this.log("Received JSON " + Data);
        let Response;
        try {
            Response = JSON.parse(Data);
        }
        catch (e) {
            return this.error_unrecognized_response(Data);
        }
        switch (Response.type) {
            case "result":
                this.parse_response_result(Response);
                break;
            case "callback":
                if (this.logged) {
                    this.call_callback(Response);
                }
                else {
                    this.callback_queue.push(Response);
                }
                break;
            case "system":
                if (Response.data == "ping") {
                    this.send_pong();
                }
                break;
            default:
                this.error_unrecognized_response(Data);
        }
    }
    call_callback(Response) {
        const Plugin = Response.plugin;
        const Action = Response.action;
        const CallbackData = Response.data;
        const ActionFn = "callback__" + Action;
        if (Plugin == "hitagi") {
            this[ActionFn](CallbackData);
            return;
        }
        if (!this[Plugin]) {
            //this.error_unrecognized_response(Data);
            return;
        }
        if (!this[Plugin][ActionFn]) {
            //this.error_unrecognized_response(Data);
            this.fire_event(Plugin + ":" + Action, CallbackData);
            //console.log(Plugin + ":" + Action, CallbackData)
            return;
        }
        this[Plugin][ActionFn](CallbackData);
    }
    connect(Config, Success, Error) {
        if (this.connection_status == "connected") {
            this.on_socket_open(Success, Error);
            return;
        }
        if (this.connection_status == "connecting") {
            return;
        }
        this.connection_status = "connecting";
        try {
            this.set_config(Config);
        }
        catch (e) {
            return this.error_config_error();
        }
        if (!this.config.ServerUri)
            return this.error_config_error();
        this.log("Opening connection to " + this.config.ServerUri);
        let Socket;
        try {
            Socket = new WebSocket(this.config.ServerUri);
        }
        catch (e) {
            Error();
            return this.error_socket_error();
        }
        const that = this;
        Socket.onopen = function () {
            that.on_socket_open(Success, Error);
            clearInterval(that.ping_interval);
            that.ping_interval = setInterval(that.send_ping(), 30000);
        };
        Socket.onerror = function () {
            that.fire_event("error", that.error_socket_error());
            if (Error) {
                Error();
            }
            return that.error_socket_error();
        };
        Socket.onmessage = function (Event) {
            that.on_socket_message(Event.data);
        };
        Socket.onclose = function () {
            if (that.socket != Socket)
                return;
            clearInterval(that.ping_interval);
            that.connection_status = "closed";
            that.logged = false;
            that.fire_event("close", null);
            that.log("Socket closed");
        };
        this.socket = Socket;
    }
    login(Config, Success, Error) {
        try {
            this.set_config(Config);
        }
        catch (e) {
            this.error_config_error();
        }
        const that = this;
        if (this.connection_status != "connected") {
            this.connect(Config, function () {
                that._do_login(Success, Error);
            }, Error);
        }
        else {
            this._do_login(Success, Error);
        }
        return this;
    }
    _do_login(Success, Error) {
        const Message = {
            "plugin": "login",
            "action": "login",
            "args": {
                "uid": this.config.Uid,
                "nick": this.config.Nick,
                "roomid": this.config.RoomId,
                "chatroom_name": this.config.ChatroomName,
                "roompassword": this.config.RoomPassword,
                "token": this.config.Token,
                "device-token": this.config.DeviceToken,
                "additional-info": this.config.AdditionalInfo,
                "payment_allowed": this.config.PaymentAllowed
            }
        };
        const that = this;
        this.send(Message, function (Args) {
            that.log("Login successful");
            that.connection_status = "connected";
            that.logged = true;
            if (Success) {
                Success(Args);
            }
            for (const i in that.callback_queue) {
                that.call_callback(that.callback_queue[i]);
            }
            // that.disconnect_others()
        }, function (Code, Message, Data) {
            that.log("Login failed");
            that.connection_status = "disconnected";
            that.logged = false;
            if (that.socket) {
                that.socket.close();
            }
            if (Error) {
                Error(Code, Message, Data);
            }
        });
    }
    logout() {
        if (this.socket) {
            this.socket.close();
        }
        this.connection_status = "closed";
    }
    disconnect_other() {
        const Message = {
            "plugin": "login",
            "action": "disconnect_other",
            "args": {}
        };
        this.send(Message, function (Args) { }, function (Code, Message, Data) { });
    }
    on_socket_open(Success, Error) {
        this.log("Socket open");
        this.connection_status = "connected";
        if (Success) {
            Success();
        }
    }
    on_login(Func) {
        this.on("login", Func);
    }
    on_message(Func) {
        this.on("message", Func);
    }
    on_error(Func) {
        this.on("error", Func);
    }
    on_close(Func) {
        this.on("close", Func);
    }
    on(Event, Func) {
        if (!this.events[Event]) {
            this.events[Event] = [];
        }
        this.events[Event].push(Func);
    }
    clear_event(Event) {
        delete this.events[Event];
    }
    fire_event(Event, Data) {
        const Handlers = this.events[Event];
        if (Handlers) {
            for (let i = Handlers.length - 1; i >= 0; i--) {
                if (typeof Handlers[i] == "function")
                    Handlers[i](Data);
            }
        }
    }
    call_event(Events, Data) {
        for (let i = Events.length - 1; i >= 0; i--) {
            Events[i](Data);
        }
    }
    log(Message) {
        if (this.config.__debug__) {
            console.log(this.config.Name + ": " + Message);
        }
    }
    send(Message, Success, Error) {
        const Packet = {
            action: Message.action,
            args: Message.args
        };
        if (Message.plugin) {
            Packet.plugin = Message.plugin;
        }
        /*Packet.args.uid = this.Config.Uid;
        Packet.args.nick = this.Config.Nick;
        Packet.args.roomid = this.Config.RoomId;
        Packet.args.token = this.Config.Token;
        */
        Packet.args.timestamp = Math.round(+new Date() / 1000);
        Packet.args.messageid = ++this.message_counter;
        Message.status = "sended";
        Message.on_error = Error;
        Message.on_success = Success;
        this.log("Sending JSON " + JSON.stringify(Packet));
        try {
            if (!this.socket || this.socket.readyState != 1) {
                throw "Socket not open";
            }
            this.socket.send(JSON.stringify(Packet));
        }
        catch (e) {
            this.error_socket_error();
            if (typeof Error == "function") {
                Error();
            }
            return;
        }
        this.message_queue[this.message_counter] = Message;
        this.timeout(Message);
    }
    action(Plugin, Action, Args, Success, Error) {
        if (!Args)
            Args = {};
        const Packet = {
            "plugin": Plugin,
            "action": Action,
            "args": Args
        };
        this.send(Packet, Success, Error);
    }
    timeout(Message) {
        const that = this;
        setTimeout(function () {
            // If message is NULL, it means it was removed from queue by it's own handler. return
            if (that.message_queue[Message.args.messageid] == null)
                return;
            if (that.message_queue[Message.args.messageid].status != "sended")
                return;
            that.message_queue[Message.args.messageid].status = "timeout";
            that.error_message_timeout(Message);
            if (Message.on_error) {
                Message.on_error("timeout");
            }
            delete that.message_queue[Message.args.messageid];
        }, this.config.Timeout);
    }
    send_ping() {
        const that = this;
        return function () {
            if (that.socket) {
                that.socket.send("ping");
            }
        };
    }
    send_pong() {
        if (this.socket) {
            this.socket.send("pong");
        }
    }
    callback__disconnect() {
        this.logged = false;
        this.fire_event("disconnect", {});
    }
}
exports.default = hitagi;
